function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { forwardRef, useState, useEffect } from "react";
import { Container, Row, Col, Table } from 'react-bootstrap';
import { Divider, Descriptions, Row as ARow, Col as ACol, Tag, Alert, Image, QRCode, Space } from 'antd';
import 'bootstrap/dist/css/bootstrap.min.css';
import DocumentHeader from "./DocumentHeader";
import DocumentFooter from "./DocumentFooter";
import { Parser } from 'html-to-react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var LaboratorySheet = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var queue_item = _ref.queue_item;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    ItemsList = _useState2[0],
    setItemsList = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    uncategorisedItemsList = _useState4[0],
    setUncategorisedItemsList = _useState4[1];
  var groupByService = function groupByService(items) {
    return Object.values(items.reduce(function (acc, item) {
      var businessAccountMedicalItemCategoryId = item.business_account_medical_item_category_id;
      if (!acc[businessAccountMedicalItemCategoryId]) {
        acc[businessAccountMedicalItemCategoryId] = _defineProperty(_defineProperty({
          business_account_medical_item_category_label: item.business_account_medical_item_category_label,
          sample_id: item.sample_id,
          item_label: item.item_label,
          result: item.result,
          normal_value: item.normal_value,
          business_account_medical_item_category_id: item.business_account_medical_item_category_id
        }, "business_account_medical_item_category_label", item.business_account_medical_item_category_label), "items", []);
      }
      acc[businessAccountMedicalItemCategoryId].items.push(item);
      return acc;
    }, {}));
  };
  useEffect(function () {
    setItemsList([]);
    queue_item && queue_item.queue_item_elements.forEach(function (e) {
      if (e.laboratory_result && e.business_account_medical_item) {
        if (e.business_account_medical_item.business_account_medical_item_category) setItemsList(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            sample_id: e.laboratory_result.sample_id,
            item_label: e.business_account_medical_item.label,
            result: e.laboratory_result.result_string,
            normal_value: e.laboratory_result.normal_value,
            business_account_medical_item_category_id: e.business_account_medical_item.business_account_medical_item_category ? e.business_account_medical_item.business_account_medical_item_category_id : 0,
            business_account_medical_item_category_label: e.business_account_medical_item.business_account_medical_item_category ? e.business_account_medical_item.business_account_medical_item_category.label : "AUTRES"
          }]);
        });
        if (e.business_account_medical_item.business_account_medical_item_category == null) setUncategorisedItemsList(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            sample_id: e.laboratory_result.sample_id,
            item_label: e.business_account_medical_item.label,
            result: e.laboratory_result.result_string,
            normal_value: e.laboratory_result.normal_value,
            business_account_medical_item_category_id: e.business_account_medical_item.business_account_medical_item_category ? e.business_account_medical_item.business_account_medical_item_category_id : 0,
            business_account_medical_item_category_label: e.business_account_medical_item.business_account_medical_item_category ? e.business_account_medical_item.business_account_medical_item_category.label : "AUTRES"
          }]);
        });
      }
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs("div", {
        ref: ref,
        id: "printable",
        style: {
          padding: "20px"
        },
        children: [/*#__PURE__*/_jsx(DocumentHeader, {
          title: "FICHE DE LABORATOIRE"
        }), /*#__PURE__*/_jsx(ARow, {
          children: /*#__PURE__*/_jsx(ACol, {
            span: 24,
            children: /*#__PURE__*/_jsxs(Table, {
              bordered: true,
              responsive: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "N.Echantillon"
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Examen"
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Resultat"
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Valeur normale"
                  })]
                })
              }), /*#__PURE__*/_jsxs("tbody", {
                children: [groupByService(ItemsList).map(function (group, index) {
                  return /*#__PURE__*/_jsxs(React.Fragment, {
                    children: [/*#__PURE__*/_jsx("tr", {
                      className: "table-secondary",
                      children: /*#__PURE__*/_jsx("td", {
                        colSpan: 4,
                        children: /*#__PURE__*/_jsx("strong", {
                          children: group.business_account_medical_item_category_label
                        })
                      })
                    }), group.items.map(function (item) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: item.sample_id
                        }), /*#__PURE__*/_jsx("td", {
                          children: item.item_label
                        }), /*#__PURE__*/_jsx("td", {
                          children: Parser().parse(item.result)
                        }), /*#__PURE__*/_jsx("td", {
                          children: item.normal_value
                        })]
                      }, item.id);
                    })]
                  }, index);
                }), groupByService(uncategorisedItemsList).map(function (group, index) {
                  return /*#__PURE__*/_jsxs(React.Fragment, {
                    children: [/*#__PURE__*/_jsx("tr", {
                      className: "table-secondary",
                      children: /*#__PURE__*/_jsx("td", {
                        colSpan: 4,
                        children: /*#__PURE__*/_jsx("strong", {
                          children: group.business_account_medical_item_category_label
                        })
                      })
                    }), group.items.map(function (item) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: item.sample_id
                        }), /*#__PURE__*/_jsx("td", {
                          children: item.item_label
                        }), /*#__PURE__*/_jsx("td", {
                          children: Parser().parse(item.result)
                        }), /*#__PURE__*/_jsx("td", {
                          children: item.normal_value
                        })]
                      }, item.id);
                    })]
                  }, index);
                })]
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(ARow, {
          children: /*#__PURE__*/_jsx(ACol, {
            span: 8,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                textAlign: 'center'
              },
              children: /*#__PURE__*/_jsx("h5", {
                children: "Le Responsable du Laboratoire"
              })
            })
          })
        }), /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            lg: 6,
            md: 6,
            sm: 6
          }), /*#__PURE__*/_jsx(Col, {
            style: {
              "float": 'left',
              width: '46%'
            },
            className: "g-col-6",
            lg: 6,
            md: 6,
            sm: 6
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), " ", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(DocumentFooter, {})]
  });
});
export default LaboratorySheet;